import * as Yup from 'yup'

export const RequirementBasicSchema = Yup.object({
  title: Yup.string()
    .trim()
    .required('INPUT.VALIDATION.REQUIREMENT.TITLE'),
  description: Yup.string()
    .trim()
    .required('INPUT.VALIDATION.REQUIREMENT.DESCRIPTION'),
  business_types: Yup.array()
    .of(Yup.string().trim())
    .min(1, 'INPUT.VALIDATION.REQUIREMENT.BUSINESSTYPES')
    .required('INPUT.VALIDATION.REQUIREMENT.BUSINESSTYPES'),
  service_types: Yup.array()
    .of(Yup.string().trim())
    .min(1, 'INPUT.VALIDATION.REQUIREMENT.SERVICETYPES')
    .required('INPUT.VALIDATION.REQUIREMENT.SERVICETYPES'),
  area: Yup.string()
    .trim()
    .required('INPUT.VALIDATION.REQUIREMENT.AREA'),
  area_type: Yup.string()
    .trim()
    .required('INPUT.VALIDATION.REQUIREMENT.AREATYPE'),
  frequency: Yup.string()
    .trim()
    .required('INPUT.VALIDATION.REQUIREMENT.FREQUENCY'),
  duration: Yup.string()
    .trim()
    .required('INPUT.VALIDATION.REQUIREMENT.DURATION'),
  start_date: Yup.date()
    .typeError('INPUT.VALIDATION.REQUIREMENT.STARTDATE')
    .required('INPUT.VALIDATION.REQUIREMENT.STARTDATE')
    .test('start-not-in-past', 'INPUT.VALIDATION.REQUIREMENT.STARTDATE.NOTPAST', (value) => {
      if (!value) return false
      const today = new Date()
      today.setHours(0,0,0,0)
      const d = new Date(value)
      d.setHours(0,0,0,0)
      return d.getTime() >= today.getTime()
    }),
  budget: Yup.string()
    .required('INPUT.VALIDATION.REQUIREMENT.BUDGET')
    .test('is-number','INPUT.VALIDATION.REQUIREMENT.BUDGET.NUMBER', (v) => {
      if (v === undefined || v === null || v === '') return false
      const n = Number(String(v).replace(/,/g, ''))
      return Number.isFinite(n)
    })
    .test('min-amount','INPUT.VALIDATION.REQUIREMENT.BUDGET.MIN', (v) => {
      const n = Number(String(v).replace(/,/g, ''))
      return Number.isFinite(n) && n >= 100
    }),
})

export type RequirementBasicSchemaType = Yup.InferType<typeof RequirementBasicSchema>
